import { Component, Input } from "@angular/core";

export type CdnImageSize = "xs" | "sm" | "md" | "lg" | "xl";

@Component({
  selector: "cdn-img",
  templateUrl: "./cdn-img.component.html",
  styleUrls: ["./cdn-img.component.scss"],
  standalone: false,
})
export class CdnImgComponent {
  @Input() alt = "";
  @Input({ required: true }) size!: CdnImageSize;
  @Input({ required: true }) src!: string;

  get proxiedSrc(): string {
    if (!this.src) {
      return "";
    }

    let srcWithDomainIfAsset = this.src;

    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

    if (!this.src.startsWith("http://") && !this.src.startsWith("https://")) {
      if (isLocalhost) {
        return this.src;
      }
      srcWithDomainIfAsset = `${window.location.origin}/${this.src}`;
    }

    const requestedWidth = this.getSizeInPixels();
    const screenWidth = window.innerWidth * (window.devicePixelRatio || 1);
    const targetWidth = Math.min(requestedWidth, screenWidth);
    const optimizedWidth = this.getNextLargestSize(targetWidth);

    return `https://proxied-cdn.rocketcloset-cdn.com/cdn-cgi/image/width=${optimizedWidth},format=webp/${srcWithDomainIfAsset}`;
  }

  private getSizeInPixels(): number {
    switch (this.size) {
      case "xs":
        return 50;
      case "sm":
        return 200;
      case "md":
        return 750;
      case "lg":
        return 1440;
      case "xl":
        return 1960;
    }
  }

  private getNextLargestSize(targetWidth: number): number {
    const availableSizes = [50, 200, 750, 1440, 1960];

    for (const size of availableSizes) {
      if (size >= targetWidth) {
        return size;
      }
    }

    return availableSizes[availableSizes.length - 1];
  }
}
